'use strict';

exports.encode = require('./encode');
exports.decode = require('./decode');
